import {AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren} from '@angular/core';
import { Platform } from '@ionic/angular';

// threefold panel with an 3-arc-diagram
@Component({
  selector: 'three-pane-3',
  templateUrl: 'three-pane-3.html',
  styleUrls: ['three-pane-3.scss'],
})
export class ThreePane3 implements AfterViewChecked {

  @Input() public title: string;

  @Input() public label: string;

  @Input() public text: string;

  @Input() public data: Array<any>;

  @Output() public interactionClicked: EventEmitter<void> = new EventEmitter<void>();

/*  public get hideText(): string {
    if ( !this.doCheckStacks ) {
      return 'hide-text';
    }
    return this.checkStack(0) && this.checkStack(1) && this.checkStack(2) ? '' : 'hide-text';
  };*/

  public hideText = 'hide-text';


  @ViewChildren('stack') stacks: QueryList<ElementRef>;
  @ViewChildren('labels') labels: QueryList<ElementRef>;
  @ViewChildren('text') texts: QueryList<ElementRef>;

  private doCheckStacks: boolean = false;

  
  constructor(
    private platform: Platform,
  ) {
    this.platform.ready().then(() => {
      console.log('before subscribe');
      this.platform.resize.subscribe(() => {
        if ( this.doCheckStacks ) {
          this.hideText = this.checkStack(0) && this.checkStack(1) && this.checkStack(2) ? '' : 'hide-text';
          this.doCheckStacks = true;
        }
      });
    });
  }

  public onInteractionClicked(event: Event): void {
    event.stopPropagation();
    this.interactionClicked.emit();
  }

  ngAfterViewChecked() {
    if ( !this.doCheckStacks ) {
      // console.log("ngAfterViewChecked thr3");
      this.doCheckStacks = true;
      setTimeout(() => { 
        this.hideText = this.checkStack(0) && this.checkStack(1) && this.checkStack(2) ? '' : 'hide-text';
      });
    }
  }

  private checkStack(i: number): boolean {
    const d1: HTMLDivElement = this.stacks.toArray()[i].nativeElement;
    const d2: HTMLDivElement = this.labels.toArray()[i].nativeElement;
    const d3: HTMLDivElement = this.texts.toArray()[i].nativeElement;

    const h1 = d1.offsetHeight;
    const h2 = d2.offsetHeight;
    const h3 = d3.offsetHeight;
    const heightOk = (h1 +2 >= h2+h3);

    const w1 = d1.offsetWidth;
    const w2 = d2.offsetWidth;
    const w3 = d3.offsetWidth;
    const widthOk = (w1 +2  >= w2+w3);
//    const widthOk = true;
    // console.log("## " + i + ": " + h1 + " vs " + (h2+h3)+ ": "+heightOk + " || " + w1 + " vs " + (w2+w3)+ ": "+widthOk);
    return heightOk || widthOk;

  }
}
